export interface TopicItem {
  id: string;
  title: string;
  description: string;
  cover: string;
  itemIds: string[];
}

export const topics: TopicItem[] = [
  {
    id: "tp001",
    title: "高分悬疑烧脑合集",
    description: "汇集近年来豆瓣高分悬疑作品，层层反转，烧脑过瘾。",
    cover: "https://readdy.ai/api/search-image?query=Collage-style%20cinematic%20banner%20for%20mystery%20thriller%20film%20collection%2C%20dark%20blue%20tones%20with%20subtle%20orange%20spotlight%2C%20magnifying%20glass%20and%20film%20reel%20silhouette%2C%20moody%20atmosphere&width=800&height=500&seq=topic-tp001-01&orientation=landscape",
    itemIds: ["m001", "m004", "t001", "t003"],
  },
  {
    id: "tp002",
    title: "温情治愈家庭剧场",
    description: "不煽情却直抵人心，适合与家人一起观看的温暖作品。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20banner%20for%20family%20heartwarming%20drama%20collection%2C%20soft%20orange%20golden%20hour%20light%2C%20cozy%20home%20silhouette%2C%20gentle%20nostalgic%20atmosphere&width=800&height=500&seq=topic-tp002-01&orientation=landscape",
    itemIds: ["m003", "t002", "t004"],
  },
  {
    id: "tp003",
    title: "星际科幻探索之旅",
    description: "跨越星海的想象力盛宴，带你领略未来世界的无限可能。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20banner%20for%20sci-fi%20space%20exploration%20film%20collection%2C%20deep%20navy%20blue%20galaxy%20background%20with%20warm%20orange%20nebula%20accent%2C%20futuristic%20epic%20atmosphere&width=800&height=500&seq=topic-tp003-01&orientation=landscape",
    itemIds: ["m002", "t001"],
  },
];

export const getTopicById = (id: string) => topics.find((t) => t.id === id);